const STORAGE_KEY = "reports.recentRecordingSelections";
const MAX_RECENT_ITEMS = 5;

export type RecentRecordingSelection = {
  recordingId: string;
  label: string;
  patientName: string;
  mrn: string;
  examId: string;
  studyDate: string;
};

export function readRecentRecordingSelections(): RecentRecordingSelection[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.slice(0, MAX_RECENT_ITEMS) : [];
  } catch {
    return [];
  }
}

export function rememberRecentRecordingSelection(
  item: RecentRecordingSelection,
): void {
  if (typeof window === "undefined") return;
  const existing = readRecentRecordingSelections().filter(
    (entry) => entry.recordingId !== item.recordingId,
  );
  const next = [item, ...existing].slice(0, MAX_RECENT_ITEMS);
  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
}

export function formatRecordingSearchLabel(input: {
  patientName: string;
  mrn: string;
  examId: string;
  studyDate?: string | null;
}): string {
  const dateLabel = input.studyDate
    ? new Date(input.studyDate).toLocaleDateString()
    : "—";
  return `${input.patientName} · MRN ${input.mrn} · Exam ${input.examId} · ${dateLabel}`;
}
